import { render, staticRenderFns } from "./SegmentTablesComponent.vue?vue&type=template&id=f67fb08c"
import script from "./SegmentTablesComponent.vue?vue&type=script&lang=js"
export * from "./SegmentTablesComponent.vue?vue&type=script&lang=js"
import style0 from "./SegmentTablesComponent.vue?vue&type=style&index=0&id=f67fb08c&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f67fb08c')) {
      api.createRecord('f67fb08c', component.options)
    } else {
      api.reload('f67fb08c', component.options)
    }
    module.hot.accept("./SegmentTablesComponent.vue?vue&type=template&id=f67fb08c", function () {
      api.rerender('f67fb08c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/audiences/components/SegmentTablesComponent.vue"
export default component.exports